import {collectLegacyRecoverySources, legacyPositiveId} from './legacyRecoverySources.js';
import {verifiedLegacyRecoveryCoverage, isPendingLegacyRecord} from './legacyVisitRecovery.js';
import {OFFLINE_STORES} from './offlineStorageAdapter.js';

const MAIN = 'coordinacion_visitas_offline/';
const parsed = value => typeof value === 'string' ? JSON.parse(value) : value;
const object = value => value && typeof value === 'object' && !Array.isArray(value);

// Web comparte el nombre de la antigua base de borradores. No se puede copiar
// sobre ella ni enviar un snapshot sin base como si fuera un delta actual.
// Esto es preflight de conservación, no activa una migración web no certificada.
export async function inspectWebLegacyReadiness({driver, collect = collectLegacyRecoverySources, fs} = {}) {
    const sources = await collect(), covered = await verifiedLegacyRecoveryCoverage({driver, fs}), pending = [];
    const imported = driver.webVisitAuthority ? await driver.importedSourceFingerprints() : null;
    for (const item of sources.records) {
        if (covered.has(item.fingerprint)) continue;
        try {
            const raw = item.raw;
            if (!isPendingLegacyRecord(raw) && item.type !== 'FILES') continue;
            // En web estos stores ya pertenecen a la autoridad vigente de sus
            // módulos. Este preflight acotado no los migra ni los reinterpreta.
            if (item.source.startsWith(MAIN) && !['ENTRIES', 'OPERATIONS', 'MEDIA', 'FILES'].includes(item.type)) continue;
            if (imported) {
                if (!imported.has(item.fingerprint)) pending.push({source:item.source,type:item.type,
                    reason:'La fuente anterior conserva pendientes sin una copia verificada en la autoridad web.'});
                continue;
            }
            const userId = legacyPositiveId(raw.userId), visitaId = legacyPositiveId(raw.visitaId);
            let current = item.source.startsWith(MAIN) && userId && visitaId;
            if (item.type === 'ENTRIES') {
                const payload = parsed(raw.payload);
                current &&= raw.key === `${userId}:${visitaId}` && typeof raw.revisionId === 'string' && !!raw.revisionId
                    && object(payload?._local_first?.base) && object(payload.responses);
            } else if (item.type === 'OPERATIONS') {
                const payload = parsed(raw.payload);
                current &&= typeof raw.id === 'string' && !!raw.id && typeof raw.operation_uuid === 'string' && !!raw.operation_uuid
                    && object(payload) && typeof raw.type === 'string' && !!raw.type;
            } else if (item.type === 'MEDIA') {
                const file = current && await driver.get(OFFLINE_STORES.FILES, raw.id);
                current &&= file?.schemaVersion === 1 && file.userId === userId && file.visitaId === visitaId
                    && ['linked', 'acknowledged'].includes(file.state) && raw.filePath === file.path && raw.size === file.size;
            } else if (item.type === 'FILES') {
                current &&= raw.schemaVersion === 1 && raw.path === `offline-files/${userId}/${raw.id}.bin`
                    && typeof raw.sha256 === 'string' && /^[a-f0-9]{64}$/.test(raw.sha256) && Number.isSafeInteger(raw.size) && raw.size > 0;
            } else current = false;
            if (!current) pending.push({source: item.source, type: item.type, reason: 'La fuente anterior necesita una recuperación web aislada; no se envía ni se sustituye.'});
        } catch {pending.push({source: item.source, type: item.type, reason: 'No se pudo comprobar el formato anterior. Se conserva sin enviar.'});}
    }
    return {complete: sources.errors.length === 0, knownPending: pending.length, preserved: true, sources: pending};
}
